export const ingoTea = {
  id: "ingoTea",
  link: "/#/recipes/recipes/ingoTea",
  name: "Ingo Tea",
  cuisine: "Kharbranthian",
  summary: "Hibiscus and mint tea, served warm or cold",
  inspiration: "Agua de Jamaica",
  quantity: "1/2 gallon",
  time: "90 minutes",
  notes:
    "This one took some serious brainstorming. The issue at play here is that the book describes this tea using the word \"boiled.\" In general, that is not a thing you do to tea. Ever. So I needed to find something you could make tea out of by boiling, that would also taste good with mint. Fortunately I remembered making agua de jamaica. While I don't think of jamaica as a tea, it's not really that different. It ended up working really well to boil the hibiscus first, then steep the mint after. It tastes good and matches the description in the book. This can be served either hot or chilled, though I prefer it chilled.",
  quotes:
    "Taravangian leaned forward, holding his warm drink. Boiled ingo tea, with mint. Smells of home. (Oathbringer ch 107)",
  image: "https://jozomby-public.s3.amazonaws.com/recipes/ingo-tea-overview.jpg",
  ingredientSections: [
    {
      title: null,
      ingredients: [
        {
          item: "water",
          display: "about 1/2 gallon water"
        },
        {
          item: "hibiscus",
          display: "1/2 cup dried hibiscus flowers"
        },
        {
          item: "mint",
          display: "1 cup mint leaves, lightly crushed and packed"
        },
        {
          item: "sugar",
          display: "2 tbsp plus 2 tsp granulated sugar, plus additional if desired"
        }
      ]
    }
  ],
  steps: [
    "Bring 2 cups water to boil in a pot over high heat. Add the hibiscus flowers. Reduce to simmer, and simmer uncovered for 10 minutes.",
    "Remove from heat and let sit for 1 hour.",
    "Strain, reserving the liquid. Press the flours to get any extra liquid out, then discard the flowers.",
    "Add enough water to the liquid to raise the total amount to 1/2 gallon. Bring the diluted mixture to a boil over high heat. Remove from heat.",
    "Roll the mint leaves between your fingers to lightly crush and release the oils. Lightly pack them together and measure 1 cup of leaves. Add them to the pot and let steep in the liquid for 5 minutes.",
    "Remove the mint leaves and mix in the sugar, plus additional to taste if you prefer it sweeter. Serve hot or chilled."
  ]
}
